import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { HeaderTitleProps } from '../../../../types/headerTitleProps'
import { PlanName } from '../PlanName'

export const DuoTitle = (props: HeaderTitleProps) => {
  const { isDuoSelected } = usePlansContext()

  return <PlanName isSelected={isDuoSelected} {...props} />
}
